// extracted by mini-css-extract-plugin
export default {"plate-input":"customer-form_plate-input__zbauK"};